import { Component, OnInit } from '@angular/core';

@Component({

  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  scroll(targetId) {
    document.getElementById(targetId).scrollIntoView({block: 'start',  behavior: 'smooth'});
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts